class GiftCardPopup extends window.BAO.CustomElement() {
  connectedCallback () {
    if (sessionStorage.getItem('giftCardPopupClosed') === 'true') {
      return
    }
    this.externalEls.dialog.element.showModal()

    this.setupListeners()
  }

  setupListeners () {
    this.listeners.add(
      this.els.close.element,
      'click',
      this.handleClose.bind(this),
    )
  }

  handleClose () {
    this.externalEls.dialog.element.close()
    sessionStorage.setItem('giftCardPopupClosed', 'true')
  }
}

if (!customElements.get('gift-card-popup')) {
  customElements.define('gift-card-popup', GiftCardPopup)
}
